import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { UserModel } from '../models/user.model';

import { UserService } from './user.service';

@Injectable()
export class PwdService {
  private readonly colors = ['#F00', '#F90', '#9F0', '#0F0'];
  private readonly labels = ['Baixo', 'Razoável', 'Bom', 'Forte'];
  bar0: string;
  bar1: string;
  bar2: string;
  bar3: string;
  user: UserModel;
  company: string;

  path: string;

  constructor(
    private readonly router: Router,
    protected userService: UserService
  ) {
    this.path = this.router.url;

    if (this.path.includes('user-recovery') || this.path.includes('user-verify')) {
      this.company = ' ';
    } else {
      this.user = this.userService.getUser();
      this.company = this.user.retailerAlias.toUpperCase().replace(/\s/g, '');
    }
  }

  private measureStrength(p) {
    let force: number;
    const regex = /[@$-/.:-?{-~!"^_`\[\]]/g;
    const regWord = /(>|!|"|SAP|PASS|PASSWORD|EREDES|\?)/g;
    const regSpace = /\s/g;
    const regRow = /([A-Za-z0-9$#%@&=.+*()[\]{}:;\\<,\'.:\/_-])\1{2}/g;
    const regCompany = new RegExp('(' + this.company + ')', 'g');

    const lowerLetters = /[a-z]+/.test(p);
    const upperLetters = /[A-Z]+/.test(p);
    const numbers = /[0-9]+/.test(p);
    const symbols = regex.test(p);
    const words = !regWord.test(p.toUpperCase());
    const space = !regSpace.test(p);
    const repeat = !regRow.test(p);
    const companyName = !regCompany.test(p.toUpperCase());

    const flags = [lowerLetters, upperLetters, numbers, symbols, words, space, repeat, companyName];

    let passedMatches = 0;
    for (const flag of flags) {
      passedMatches += flag === true ? 1 : 0;
    }

    switch (passedMatches) {
      case 4:
        force = Math.min(force, 10);
        break;

      case 5:
        force = Math.min(force, 20);
        break;

      case 8:
        force += passedMatches * 10;
        if (p.length < 10) {
          force = Math.min(force, 20);
        } else if (p.length === 10) {
          force = Math.min(force, 40);
        } else {
          force = Math.min(force, 60);
        }
        break;

      default:
        force = 0;
    }

    return force;
  }

  private getColor(s) {
    let idx: number;
    if (s <= 10) {
      idx = 0;
    } else if (s <= 20) {
      idx = 1;
    } else if (s <= 40) {
      idx = 2;
    } else {
      idx = 3;
    }

    return {
      idx: idx + 1,
      col: this.colors[idx],
      label: this.labels[idx],
    };
  }

  onChangePwd(pwd): any {
    const password = pwd;
    let c;
    let barArray = [];
    let invalid = false;
    barArray = this.setBarColors(4, '#DDD', barArray);

    if (password) {
      c = this.getColor(this.measureStrength(password));
      barArray = this.setBarColors(c.idx, c.col, barArray);
      c.barArray = barArray;
    }
    if (c && (c.label === 'Baixo' || c.label === 'Razoável')) {
      invalid = true;
    }

    return c || { barArray, invalid };
  }

  setBarColors(count, col, barArray) {
    if (!barArray) {
      barArray = [];
    }
    for (let n = 0; n < count; n++) {
      this['bar' + n] = col;
      barArray[n] = this['bar' + n];
    }

    return barArray;
  }
}
